import { createAction, props } from '@ngrx/store';
import { EnvironmentResponse } from './environment.models';

/**
 * The action to use when we receive a response from the environment service
 */
export const environmentLoadedSuccess = createAction(
	'[Environment Effects] Environment Loaded Success',
	props<{ payload: EnvironmentResponse }>()
);

/**
 * Tell the application that we failed to load the environment
 */
export const environmentLoadedFailure = createAction('[Environment Effects] Environment Loaded Failed');
